<template>
  <nav ref="menu" class="nav">
    <MenuToggle />

    <AppIcon />

    <Menu />

    <AppVersion />
  </nav>
</template>

<script>
import MenuToggle from './MenuToggle'
import AppIcon from './AppIcon'
import Menu from './Menu'
import AppVersion from './AppVersion'

export default {
  components: { MenuToggle, AppIcon, Menu, AppVersion },

  computed: {
    isMobile() {
      return this.$store.state.dom.windowWidth <= 768
    },
  },
}
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  left: -$navbarWidth;
  z-index: 6;
  width: $navbarWidth;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: $color-gray-25;

  @include transition(left 0.1s ease);
  @include createFlex(flexbox, nowrap, column, flex-start, stretch, stretch);

  @include media_tablet() {
    left: 0;
  }

  &.opened-menu {
    left: 0;
  }

  .router-link-exact-active {
    background: $color-gray-100;
  }
}
</style>
